import React from 'react';
import { useTranslation } from 'react-i18next';
import './Header.css';

function Header() {
  const { t } = useTranslation();

  return (
    <header className="header">
      <div className="container">
        <div className="hero-content animate-fade-in-up">
          <h1 className="hero-title">
            {t('header.title')}
          </h1>
          <p className="hero-subtitle">
            {t('header.subtitle')}
          </p>
          <p className="hero-location">
            {t('header.location')}
          </p>
          <div className="hero-decorative-line"></div>
        </div>

        {/* Visual Elements */}
        <div className="surfboard-element visual-element"></div>
        <div className="palm-tree-element visual-element"></div>
        <div className="incense-smoke visual-element"></div>
      </div>
    </header>
  );
}

export default Header;